var Component = require("enyo/Component"),
    config    = require("app/config"),
    deepEqual = require("fast-deep-equal"),
    get       = require("object-path").get,
    kind      = require("enyo/kind"),
    logger    = require("enyo/logger");

module.exports = kind(/** @lends  app.Sentry.SentryIOService.prototype */ {

    /**
     * @private
     */
    name: "app.Sentry.SentryIOService",

    /**
     * @private
     */
    kind: Component,

    /**
     * Cached copy of consent data, used to detect consent changes.
     *
     * @private
     */
    consent: null,

    /**
     * @method
     * @private
     */
    create: kind.inherit(function(sup) {
        return function() {
            var $privacyService = this.app.$.privacyService;

            sup.apply(this, arguments);

            // Just load the tracker
            if ($privacyService.shouldBypassConsent()) {
                this.load();
            }

            // Non-IAB vendor consent
            this.observe("app.$.privacyService.nonIABConsentData", this.onNonIABConsentDataChange);
        };
    }),

    // Vendor Transparency and Consent
    // ----------------

    /**
     * Respond to changes in consent.
     *
     * @private
     */
    onNonIABConsentDataChange: function() {
        var $privacyService = this.app.$.privacyService,
            consent         = $privacyService.get("nonIABConsentData"),
            consentChanged  = !deepEqual(this.consent, consent);

        // Update consent state
        if (consentChanged) {
            this.consent = consent;
        }
        else {
            return;
        }

        // We aren't ready yet, but are allowed to load.
        if (!this.isReady && this.hasLoadConsent()) {
            this.load();
        }

        // We are ready, but consent has just been revoked.
        else if (this.isReady && !this.hasLoadConsent()) {
            this.app.$.router.reload();
        }
    },

    // Loading
    // ----------------

    /**
     * @returns  {boolean}  Whether we have consent to load the Hotjar
     * @private
     */
    hasLoadConsent: function() {
        var $privacyService   = this.app.$.privacyService,
            nonIABConsentData = $privacyService.get("nonIABConsentData");

        // Bypass parameter set
        if ($privacyService.shouldBypassConsent()) {
            return true;
        }

        // Consent for 'advertisement' purpose required
        else {
            return nonIABConsentData
                && nonIABConsentData.accepted
                && Array.isArray(nonIABConsentData.accepted)
                && nonIABConsentData.accepted.includes("functional")
                && nonIABConsentData.accepted.includes("analytics");
        }
    },

    /**
     * @private
     */
    load: function() {
        // Sentry not enabled
        if (!get(config, "sentry.enabled", false)
            || !get(config, "sentry.dsn", null)) {
            return;
        }

        // Bail if already loaded
        if (typeof Sentry !== "undefined") {
            return;
        }

        require.ensure(["@sentry/browser"], function(require) {
            var Sentry = require("@sentry/browser");

            Sentry.init({
                dsn:          get(config, "sentry.dsn", null),
                integrations: [
                    new Sentry.BrowserTracing({
                    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
                        tracePropagationTargets: get(config, "sentry.tracePropagationTargets", [])
                    }),
                    new Sentry.Replay({
                        maskAllText:   false,
                        blockAllMedia: false
                    })
                ],

                // Performance Monitoring
                tracesSampleRate:         1.0, //  Capture 100% of the transactions
                // Session Replay
                replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
                replaysOnErrorSampleRate: 1.0 // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
            });

            // Make globally available.
            window.Sentry = Sentry;
        }, function(error) {
            logger.error(error);
        }, "sentry-io");
    }

});
